<template>
  <div class="inputbox">
    <div class="box-font">{{title}}</div>
    <div class="input-1" >
      <input type="text" placeholder="请输入"
             class="input-i"
             @input="input_name($event.target.value)"
             :value=inputValue>
      <span>{{company}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "input11",
    props:['title','company','inputValue'],
    methods:{
      input_name(e){
        this.$emit("input",e)
      }
    }
  }
</script>

<style scoped lang="scss">
  .inputbox{
    width: 153px;
    height: 60px;
    .box-font{
      font-size: 13px;
      font-weight: 500;
      text-align: left;
      color: #333333;
    }
    .input-1{
      display: flex;
      border-style: none;
      border-bottom:0.5px solid #dcdcdc;
      input{
        font-size: 14px;
      }
    }
    .input-i{
      height: 100%;
      width: 100%;
      border-style: none;
      box-sizing: border-box;
    }
  }
</style>